import React from 'react';
import { InputMask } from 'primereact/inputmask';
import { withFormikFormControl } from '../FormikFormControl';
import { FormPageFieldComponentProps } from 'types/formPage';
import {extract, wrapComponent} from "../utils";
import _ from 'lodash';

export const BarCode = ({ value, extraConfig, ...restProps }: FormPageFieldComponentProps) => {
  const comp = <InputMask value={_.isObject(value as any) ? value?.text : value} {...extract({},{},restProps)} mask="9*" />;
  return wrapComponent( comp, extraConfig )
};

export const BarCodeFormik = withFormikFormControl()(BarCode);

export default BarCodeFormik;
